import { InjectionToken } from '@angular/core';
import { ViewFiltersDialogService } from './view-filters-dialog-service.interface';

export const VIEW_FILTER_DIALOG_SERVICE_INJECTION_TOKEN: InjectionToken<ViewFiltersDialogService>
  = new InjectionToken<ViewFiltersDialogService>('VIEW_FILTER_DIALOG_SERVICE_INJECTION_TOKEN');
